// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--0-1i6";
export var container = "styles-module--container--e5j9V";
export var form = "styles-module--form--BLeDf";
export var title = "styles-module--title--UHOx9";